import { useMemo } from 'react';
import { NEW_LINE_MARKER } from '../../../../../../helpers/localize';

const CellSimpleText = ({ value }) => {
  const text = useMemo(
    () => value ?
      (Array.isArray(value)
        ? (value.length === 0 ? '-' : value.join(', %%%'))
        : value)
        .split(NEW_LINE_MARKER) : '-',
    [value],
  );

  return <div
    style={{
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    }}
  >
    {
      text.length <= 1
        ? text
        : text.map((dataLine) => <div key={dataLine}>{dataLine}</div>)
    }
  </div>;
};

export default CellSimpleText;
